import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { layerHover, shiftHover } from '@customerio/pluma-components/css/utils';

// "Sign in with Google" button — must follow Google's brand guidelines (white
// surface, control border, the Google mark), so it deviates from the
// default Pluma secondary button.
const googleAuthButtonBase = {
  borderRadius: themeVars.radius['4'],
  // eslint-disable-next-line local-rules/enforce-theme-tokens -- Google brand-guideline padding, not a Pluma token
  paddingRight: '12px',
  display: 'flex',
  background: themeVars.color['surface-content'],
  border: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-control-border']}`,
  selectors: {
    '&:hover': { backgroundColor: layerHover(themeVars.color['surface-content']) },
    '&[disabled]': { opacity: 0.5, cursor: 'default' },
    '&[disabled]:hover': { backgroundColor: themeVars.color['surface-content'] },
  },
} as const;

// Login screens: hug the content (light theme).
export const googleAuthButton = style(
  {
    ...googleAuthButtonBase,
    width: 'fit-content',
  },
  'google-auth-button',
);

// Dark theme — used by the re-auth modal (Ember's `@theme='dark'`): dark surface,
// white text, no border.
export const googleAuthButtonDark = style(
  {
    borderRadius: themeVars.radius['4'],
    // eslint-disable-next-line local-rules/enforce-theme-tokens -- Google brand-guideline padding, not a Pluma token
    paddingRight: '12px',
    display: 'flex',
    width: 'fit-content',
    background: themeVars.color['scope-action-solid-bg'],
    border: `${themeVars.border['width-0125']} solid transparent`,
    color: themeVars.palette.white,
    selectors: {
      '&:hover': { backgroundColor: shiftHover(themeVars.color['scope-action-solid-bg']) },
      '&[disabled]': { opacity: 0.5, cursor: 'default' },
      '&[disabled]:hover': { background: themeVars.color['scope-action-solid-bg'] },
    },
  },
  'google-auth-button-dark',
);

// Signup-style usage (email step "Continue with Google"): full width, centered.
export const googleSignupButton = style(
  {
    ...googleAuthButtonBase,
    width: '100%',
    justifyContent: 'center',
    // eslint-disable-next-line local-rules/enforce-theme-tokens -- Google brand-guideline padding, not a Pluma token
    paddingLeft: '12px',
    color: themeVars.color['text-primary'],
  },
  'google-signup-button',
);
